export default "__VITE_ASSET__B$G0Ybkq__"